export default __webpack_public_path__ + "static/media/juridicas.64317fd2.svg";